import { useEffect, useRef, useState } from 'react';
import PropertyCard from './PropertyCard';

const SORT_OPTIONS = ['Latest', 'Popular', 'Home Loan', 'Newest Launch', 'Price: High to Low', 'RERA Registered'];

function filterProperties(props, filters, searchText) {
  return props.filter((p) => {
    // Existing filters
    if (filters.city.length && !filters.city.some((c) => p.location.includes(c) || p.city === c)) return false;
    if (filters.locality.length && !filters.locality.some((l) => p.location.includes(l))) return false;
    if (filters.propertyType.length && !filters.propertyType.includes(p.propertyType)) return false;
    if (filters.possession.length && !filters.possession.includes(p.status)) return false;
    if (filters.configuration.length && !filters.configuration.includes(p.bhk)) return false;
    if (
      filters.builder.length &&
      !filters.builder.some((b) => (p.developer || '').toLowerCase() === (b || '').toLowerCase())
    )
      return false;

    // 🔍 NEW SEARCH FILTER
    if (searchText) {
      const text = searchText.toLowerCase();

      const matches =
        p.name?.toLowerCase().includes(text) ||
        p.builder?.toLowerCase().includes(text) ||
        p.city?.toLowerCase().includes(text) ||
        p.location?.toLowerCase().includes(text);

      if (!matches) return false;
    }

    return true;
  });
}

function SortDropdown({ selected, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="sort-wrapper" ref={ref}>
      <button className="sort-trigger regular-body light" onClick={() => setOpen((p) => !p)}>
        <span className="sort-label">Sort By:</span>
        <span>{selected}</span>
       <img src="/documents/d/global/down-chevron-2-" width={16} height={16} />
      </button>

      {open && (
        <div className="sort-dropdown-menu">
          {SORT_OPTIONS.map((opt) => (
            <div
              key={opt}
              className={`sort-option regular-body${selected === opt ? ' active' : ''}`}
              onClick={() => {
                onSelect(opt);
                setOpen(false);
              }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const PAGE_SIZE = 5;

export default function PropertyList({ appliedFilters, properties = [], loading, error, searchText = '' }) {
  const [sortBy, setSortBy] = useState('Latest');
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [loadingMore, setLoadingMore] = useState(false);

  // 🔍 APPLY SEARCH HERE
  const filtered = filterProperties(properties, appliedFilters, searchText);

  const totalCount = filtered.length;
  const visibleProperties = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < totalCount;

  const handleLoadMore = () => {
    setLoadingMore(true);
    setTimeout(() => {
      setVisibleCount((prev) => prev + PAGE_SIZE);
      setLoadingMore(false);
    }, 300);
  };

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [appliedFilters, searchText]); // reset on search also

  if (loading) {
    return <main className="listings-panel">Loading...</main>;
  }

  if (error) {
    return <main className="listings-panel">{error}</main>;
  }

  return (
    <main className="listings-panel">
      <div className="listings-header">
        <p className="listings-count regular-body font-w-400">
          Showing <strong>{totalCount}</strong> Pre-Approved Projects
        </p>
{/*         <SortDropdown selected={sortBy} onSelect={setSortBy} /> */}
      </div>

      {visibleProperties.length > 0 ? (
        <div className="property-cards-list">
          {visibleProperties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          No properties match your search.
        </div>
      )}

      {hasMore && (
        <div className="load-more-wrap">
          <button className="btn-load-more" onClick={handleLoadMore} disabled={loadingMore}>
            {loadingMore ? 'Loading...' : 'Load More'}
          </button>
        </div>
      )}
    </main>
  );
}